import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-localization',
  templateUrl: './manage-localization.component.html',
  styleUrls: ['./manage-localization.component.scss']
})
export class ManageLocalizationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
